<script setup lang="ts">
  import { useSnackbar } from './stores/snackbar';

  const props = defineProps({
    error: Object,
  });

  onMounted(() => {
    setTimeout(() => {
      navigateTo('/');
    }, 100);

    // TODO: Log error somewhere
    const snackbar = useSnackbar();

    let snackbarTitle = 'Oeps, er ging iets fout!';
    let snackbarMessage = props.error.message;

    // Add all kinds of clauses here so we have solid error handling.
    if (props.error.statusCode === 404) {
      snackbarTitle = 'Pagina niet gevonden';
      snackbarMessage =
        'De pagina die u probeert te bereiken is niet gevonden, of is niet beschikbaar.';
    }

    snackbar.setSnackbar({
      title: snackbarTitle,
      message: snackbarMessage,
    });
  });
</script>

<template>
  <div></div>
</template>
